module.exports = __webpack_public_path__ + "img/ht_icon_draft.1992c715.svg";